import { useEffect, useState } from "react";
import { getMessageTemplates } from "@api";

export const useTemplates = () => {
  const [templates, setTemplates] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ac = new AbortController();

    const load = async () => {
      try {
        setLoading(true);
        const data = await getMessageTemplates({ signal: ac.signal });
        setTemplates(data);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };

    load();

    return () => ac.abort();
  }, []);

  return { templates, loading, error };
};
